import { Modal } from "@/shared/ui/modal"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { SubmitHandler, useForm } from "react-hook-form"
import notify from "@/shared/lib/notify"
import { getErrorMessage } from "@/shared/consts/error-codes"
import { closeToggleCampaignModal, selectIsToggleCampaignModalOpen, selectOnToggle } from "../model"
import { fetchToggleCampaign } from "../model/update-marketing-campaigns-thunk"

export const ToggleMarketingCampaignModal = () => {
    const dispatch = useAppDispatch()
    const isOpen = useAppSelector(selectIsToggleCampaignModalOpen)
    const onToggle = useAppSelector(selectOnToggle)

    const handleClose = () => {
        dispatch(closeToggleCampaignModal())
    }

    const onSubmit: SubmitHandler<{}> = async () => {
        await new Promise((res, rej) => {
            dispatch(fetchToggleCampaign())
                .unwrap()
                .then(() => {
                    notify.success('Маркетинговая кампания успешно приостановлена')
                    reset()
                    res('')
                    onToggle?.()
                    handleClose()
                }).catch((e) => {
                    notify.error(getErrorMessage(e))
                    rej()
                })
        })
    }

    const {
        handleSubmit,
        reset,
        formState: {
            isSubmitting
        }
    } = useForm()

    return (
        <Modal
            isOpen={isOpen}
            title="Остановка кампании"
            onRequestClose={handleClose}
        >
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-3">
                <div>
                    Вы уверены, что хотите приостановить выбранную маркетинговую кампанию?
                </div>
                <div className="w-full flex gap-3">
                    <button onClick={handleClose} type="button" className="form_cancel_button">
                        Отменить
                    </button>
                    <button disabled={isSubmitting} className="form_handle_button" type="submit">
                        Далее
                    </button>
                </div>
            </form>
        </Modal>
    )
}